import { render, staticRenderFns } from "./PlaySticker.vue?vue&type=template&id=45277e6b&scoped=true"
import script from "./PlaySticker.vue?vue&type=script&lang=js"
export * from "./PlaySticker.vue?vue&type=script&lang=js"
import style0 from "./PlaySticker.vue?vue&type=style&index=0&id=45277e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45277e6b",
  null
  
)

export default component.exports